"use strict";

var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    className: "symbol-input-validation-error"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 6.92l-.6 1H7l.01-4H8v3zm0 4H7l.01-1.03H8v1.03zM7.5 0C3.36 0 0 3.359 0 7.5 0 11.65 3.36 15 7.5 15c4.14 0 7.5-3.35 7.5-7.5C15 3.359 11.64 0 7.5 0z"
  }));
};